import Geolocation from './Geolocation.js'
import time from './processTime.js'


export default {Geolocation,time}